import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
:root{
    &, &.light-mode{
    --color-grey-0: #fff;
    --color-grey-50: #f9fafb;
    --color-grey-100: #f3f4f6;
    --color-grey-200: #e5e7eb;
    --color-grey-300: #d1d5db;
    --color-grey-400: #9ca3af;
    --color-grey-500: #6b7280;
    --color-grey-600: #4b5563;
    --color-grey-700: #374151;
    --color-grey-800: #1f2937;
    --color-grey-900: #111827; 

    --box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.1);
}
    &.dark-mode{
    --color-grey-0: #18212f; 
    --color-grey-50: #111827; 
    --color-grey-100: #1f2937;
    --color-grey-200: #374151;
    --color-grey-300: #4b5563;
    --color-grey-400: #6b7280;
    --color-grey-500: #9ca3af;
    --color-grey-600: #d1d5db;
    --color-grey-700: #e5e7eb;  
    --color-grey-800: #f3f4f6; 
    --color-grey-900: #f9fafb;

    --box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
    
}

    --color-indigo-700: #4338ca;
}

* {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    color: var(--color-grey-800);
}

html{
    font-size: 62.5%;
   
    
}

body {
    font-family: "Roboto", sans-serif;
    background:  var(--color-grey-100);
}



`;

export default GlobalStyles;
